import { Typography } from '@material-ui/core';

import Figures, { Circle, Image } from '@components/common/figures';
// eslint-disable-next-line import/order
import useStyles from '@components/common/advantages-list/styles';

export interface ListInfo {
  circle?: Circle;
  image?: Image;
  color: 'blue' | 'purple' | 'pink' | 'yellow';
  description: string | JSX.Element; // pass key to JSX.Element
  title: string | JSX.Element;
}

interface Props {
  info: ListInfo[];
}

const List: React.FC<Props> = (props) => {
  const { info } = props;

  const classes = useStyles();

  const listItems = info.map((item, index) => {
    return (
      <div
        className={classes.item}
        key={
          typeof item.description === 'string'
            ? item.description
            : item.description.key
        }
      >
        <div className={classes.listText}>
          {item.title && (
            <Typography variant="subtitle1" className={classes.title}>
              <span className={classes[item.color]}>{index + 1}. </span>
              {item.title}
            </Typography>
          )}
          <Typography variant="body2">{item.description}</Typography>
        </div>
        {item.image && item.circle && (
          <Figures
            classWrapper={classes.listFigures}
            images={[item.image]}
            circles={[item.circle]}
          />
        )}
      </div>
    );
  });

  return <section className={classes.container}>{listItems}</section>;
};

export default List;
